// Example for LibraryAdmin page
export const profileTourSteps = [
  {
    target: "#avatarImage", // CSS selector for the element
    content: "Change your avatar image",
  },
    {
      target: "#backgroundImage", // CSS selector for the element
      content: "Change background image",
    },
    
    {
      target: "#libraryAccordion", // CSS selector for the element
      content: "Under each dog add a sub folder relating to the types of records you want to keep on file.",
    },
    {
      target: "#dashboardLinks", // Tag input field
      content: "Use these quicklinks to access portal features",
    },
  ]
  